/**
 * Calculate approximate request size in bytes
 */
export function calculateRequestSize(
    method: string,
    url: string,
    data: any,
    headers: any
): number {
    let size = 0;

    // Request line (method + url + HTTP version)
    size += method.length + url.length + 10; // "HTTP/1.1\r\n"

    // Headers
    if (headers) {
        for (const [key, value] of Object.entries(headers)) {
            if (typeof value === 'string') {
                size += key.length + value.length + 4; // ": " + "\r\n"
            }
        }
    }

    // Body
    if (data && (method === 'POST' || method === 'PUT')) {
        const bodyString = JSON.stringify(data);
        size += new Blob([bodyString]).size;
    }

    return size;
}

/**
 * Calculate approximate response size in bytes
 */
export function calculateResponseSize(response: Response, responseData: any): number {
    let size = 0;

    // Status line
    size += 15; // "HTTP/1.1 200 OK\r\n"

    // Response headers
    response.headers.forEach((value, key) => {
        size += key.length + value.length + 4; // ": " + "\r\n"
    });

    // Response body
    if (responseData !== null && responseData !== undefined) {
        const bodyString = typeof responseData === 'string'
            ? responseData
            : JSON.stringify(responseData);
        size += new Blob([bodyString]).size;
    }

    return size;
}